
const getters = {
  wslogin: state => state.app.wslogin,
  sellermenu: state => state.app.sellermenu,
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  cursystem: state => state.app.cursystem,
  mainContainerSize: state => state.app.mainContainerSize,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  websocketLogin: state => state.user.websocketLogin,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  userRemoteMenuIds: state => state.user.userRemoteMenuIds,
  brands: state => state.user.brands,
  userAuth: state => state.user.auth,
  router: state => state.user.router,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  coins: state => state.coin.coins,
  isshow: state => state.user.isshow,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js